<!-- Modal analysis -->
<div class="modal fade dirI" style="z-index: 99999;" id="modalPolygan" tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel"></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">

                <div class="reportsView">
                    <button class="btn btn-th-blue w-200 mt-2" id="moveinArea" data-bs-toggle="modal"
                        data-bs-target="#menuModal" (click)="moveInAreaClicked.emit()">حرکت داخل محدوده <i
                            class="fa fa-street-view" aria-hidden="true"></i></button>
                    <button class="btn btn-th-blue w-200 mt-2" id="analysisArea" name="analysis"
                        *ngIf="deviceInfo && access?.bAnalysDomain">تحلیل در محدوده <i class="fa fa-map"
                            aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-th-blue w-200 mt-2" id="enterExit" name="analysis">ورود و خروج <i
                            class="fa fa-external-link" aria-hidden="true"></i>
                    </button>
                    <button class="btn btn-th-blue w-200 mt-2">تخلف ورود <i class="fa fa-sign-out"
                            aria-hidden="true"></i></button>
                    <button class="btn btn-th-blue w-200 mt-2">تخلف خروج <i class="fa fa-sign-in" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>

            </div>
        </div>
    </div>
</div>
